export function shallowCompare<T>(x: T, y: T): boolean {
  if (
    typeof x !== 'object' &&
    typeof y !== 'object' &&
    x !== null &&
    y !== null
  ) {
    // tslint:disable-line:no-null-keyword
    return x === y;
  }

  if (!x || !y) {
    return false;
  }

  if (x instanceof Array && y instanceof Array) {
    const xLength = x.length;
    if (xLength !== y.length) {
      return false;
    }
    for (let i = 0; i < xLength; i++) {
      if (!shallowCompare(x[i], y[i])) {
        return false;
      }
    }
    return true;
  }

  const xKeys = Object.keys(x),
    xKeyLength = xKeys.length,
    yKeys = Object.keys(y);

  if (xKeyLength !== yKeys.length) {
    return false;
  }

  for (let i = 0; i < xKeyLength; i++) {
    if (x[xKeys[i]] !== y[xKeys[i]]) {
      return false;
    }
  }
  return true;
}
